import { ADDRESS_LINE1, ADDRESS_LINE2 } from '../constants/site';

/** Standard registered office — use everywhere the company address appears. */
export default function CompanyAddress({ className = '', as: Tag = 'address' }) {
  return (
    <Tag className={className}>
      {ADDRESS_LINE1}
      <br />
      {ADDRESS_LINE2}
    </Tag>
  );
}
